export const closeIcon = 'fa-solid fa-xmark'
export const chevronDownIcon = 'fa-solid fa-chevron-down'
export const checkIcon = 'fa-solid fa-check'
export const swapIcon = 'fa-solid fa-right-left'
export const userIcon = 'fa-solid fa-user'
export const liveChatIcon = 'fa-regular fa-comments'
export const sendMessageIcon = 'fa-regular fa-message'
export const clockIcon = 'fa-regular fa-clock'
export const leftArrowIcon = 'fa-solid fa-chevron-left'
export const eyeIcon = 'fa-solid fa-eye'
export const eyeSlashIcon = 'fa-solid fa-eye-slash'
export const bellIcon = 'fa-solid fa-bell'
export const responseIcon = 'fa-solid fa-reply'
export const logoutIcon = 'fa-solid fa-power-off'
export const disconnectIcon = 'fa-solid fa-arrow-right-from-bracket'
export const homeIcon = 'fa-solid fa-house'
export const coinIcon = 'fa-solid fa-coins'
export const getPaidIcon = 'fa-solid fa-wallet'
export const disputeIcon = 'fa-solid fa-people-arrows'
export const onGoingIcon = 'fa-solid fa-clock-rotate-left'
export const sendIcon = 'fa-solid fa-arrow-up'
export const receiveIcon = 'fa-solid fa-arrow-down'
export const helpIcon = 'fa-regular fa-circle-question'
export const directPaymentIcon = 'fa-solid fa-hand-holding-dollar'
export const trackedPaymentIcon = 'fa-solid fa-money-check-dollar'
export const copyIcon = 'fa-regular fa-copy'
